import { SvelteStyleStoreFactory, StyleUtilities, getCheckForSlotted } from '@collectivehealth/dls-styles';
import '@collectivehealth/dls-panel';
import '@collectivehealth/dls-icons/dist/es/elements/dls-icon-tooltip-small.js';

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }

    return arr2;
  }
}

function _iterableToArray(iter) {
  if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter);
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance");
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread();
}

function _CustomElement() {
  return Reflect.construct(HTMLElement, [], this.__proto__.constructor);
}

Object.setPrototypeOf(_CustomElement.prototype, HTMLElement.prototype);
Object.setPrototypeOf(_CustomElement, HTMLElement);

function noop() {}

function run(fn) {
  return fn();
}

function blank_object() {
  return Object.create(null);
}

function run_all(fns) {
  fns.forEach(run);
}

function is_function(thing) {
  return typeof thing === 'function';
}

function safe_not_equal(a, b) {
  return a != a ? b == b : a !== b || a && _typeof(a) === 'object' || typeof a === 'function';
}

function subscribe(store) {
  if (store == null) {
    return noop;
  }

  for (var _len = arguments.length, callbacks = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    callbacks[_key - 1] = arguments[_key];
  }

  var unsub = store.subscribe.apply(store, callbacks);
  return unsub.unsubscribe ? function () {
    return unsub.unsubscribe();
  } : unsub;
}

function component_subscribe(component, store, callback) {
  component.$$.on_destroy.push(subscribe(store, callback));
}

function action_destroyer(action_result) {
  return action_result && is_function(action_result.destroy) ? action_result.destroy : noop;
}

function append(target, node) {
  target.appendChild(node);
}

function insert(target, node, anchor) {
  target.insertBefore(node, anchor || null);
}

function detach(node) {
  node.parentNode.removeChild(node);
}

function element(name) {
  return document.createElement(name);
}

function text(data) {
  return document.createTextNode(data);
}

function space() {
  return text(' ');
}

function empty() {
  return text('');
}

function listen(node, event, handler, options) {
  node.addEventListener(event, handler, options);
  return function () {
    return node.removeEventListener(event, handler, options);
  };
}

function attr(node, attribute, value) {
  if (value == null) node.removeAttribute(attribute);else if (node.getAttribute(attribute) !== value) node.setAttribute(attribute, value);
}

function set_custom_element_data(node, prop, value) {
  if (prop in node) {
    node[prop] = value;
  } else {
    attr(node, prop, value);
  }
}

function children(element) {
  return Array.from(element.childNodes);
}

function set_data(text, data) {
  data = '' + data;
  if (text.data !== data) text.data = data;
}

function set_style(node, key, value, important) {
  node.style.setProperty(key, value, important ? 'important' : '');
}

var HtmlTag =
/*#__PURE__*/
function () {
  function HtmlTag(html) {
    var anchor = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

    _classCallCheck(this, HtmlTag);

    this.e = element('div');
    this.a = anchor;
    this.u(html);
  }

  _createClass(HtmlTag, [{
    key: "m",
    value: function m(target) {
      var anchor = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

      for (var i = 0; i < this.n.length; i += 1) {
        insert(target, this.n[i], anchor);
      }

      this.t = target;
    }
  }, {
    key: "u",
    value: function u(html) {
      this.e.innerHTML = html;
      this.n = Array.from(this.e.childNodes);
    }
  }, {
    key: "p",
    value: function p(html) {
      this.d();
      this.u(html);
      this.m(this.t, this.a);
    }
  }, {
    key: "d",
    value: function d() {
      this.n.forEach(detach);
    }
  }]);

  return HtmlTag;
}();

var current_component;

function set_current_component(component) {
  current_component = component;
}

var dirty_components = [];
var binding_callbacks = [];
var render_callbacks = [];
var flush_callbacks = [];
var resolved_promise = Promise.resolve();
var update_scheduled = false;

function schedule_update() {
  if (!update_scheduled) {
    update_scheduled = true;
    resolved_promise.then(flush);
  }
}

function add_render_callback(fn) {
  render_callbacks.push(fn);
}

var flushing = false;
var seen_callbacks = new Set();

function flush() {
  if (flushing) return;
  flushing = true;

  do {
    // first, call beforeUpdate functions
    // and update components
    for (var i = 0; i < dirty_components.length; i += 1) {
      var component = dirty_components[i];
      set_current_component(component);
      update(component.$$);
    }

    dirty_components.length = 0;

    while (binding_callbacks.length) {
      binding_callbacks.pop()();
    } // then, once components are updated, call
    // afterUpdate functions. This may cause
    // subsequent updates...


    for (var _i = 0; _i < render_callbacks.length; _i += 1) {
      var callback = render_callbacks[_i];

      if (!seen_callbacks.has(callback)) {
        // ...so guard against infinite loops
        seen_callbacks.add(callback);
        callback();
      }
    }

    render_callbacks.length = 0;
  } while (dirty_components.length);

  while (flush_callbacks.length) {
    flush_callbacks.pop()();
  }

  update_scheduled = false;
  flushing = false;
  seen_callbacks.clear();
}

function update($$) {
  if ($$.fragment !== null) {
    $$.update();
    run_all($$.before_update);
    var dirty = $$.dirty;
    $$.dirty = [-1];
    $$.fragment && $$.fragment.p($$.ctx, dirty);
    $$.after_update.forEach(add_render_callback);
  }
}

var outroing = new Set();

function transition_in(block, local) {
  if (block && block.i) {
    outroing.delete(block);
    block.i(local);
  }
}

var globals = typeof window !== 'undefined' ? window : global;

function mount_component(component, target, anchor) {
  var _component$$$ = component.$$,
      fragment = _component$$$.fragment,
      on_mount = _component$$$.on_mount,
      on_destroy = _component$$$.on_destroy,
      after_update = _component$$$.after_update;
  fragment && fragment.m(target, anchor); // onMount happens before the initial afterUpdate

  add_render_callback(function () {
    var new_on_destroy = on_mount.map(run).filter(is_function);

    if (on_destroy) {
      on_destroy.push.apply(on_destroy, _toConsumableArray(new_on_destroy));
    } else {
      // Edge case - component was destroyed immediately,
      // most likely as a result of a binding initialising
      run_all(new_on_destroy);
    }

    component.$$.on_mount = [];
  });
  after_update.forEach(add_render_callback);
}

function destroy_component(component, detaching) {
  var $$ = component.$$;

  if ($$.fragment !== null) {
    run_all($$.on_destroy);
    $$.fragment && $$.fragment.d(detaching); // TODO null out other refs, including component.$$ (but need to
    // preserve final state?)

    $$.on_destroy = $$.fragment = null;
    $$.ctx = [];
  }
}

function make_dirty(component, i) {
  if (component.$$.dirty[0] === -1) {
    dirty_components.push(component);
    schedule_update();
    component.$$.dirty.fill(0);
  }

  component.$$.dirty[i / 31 | 0] |= 1 << i % 31;
}

function init(component, options, instance, create_fragment, not_equal, props) {
  var dirty = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : [-1];
  var parent_component = current_component;
  set_current_component(component);
  var prop_values = options.props || {};
  var $$ = component.$$ = {
    fragment: null,
    ctx: null,
    // state
    props: props,
    update: noop,
    not_equal: not_equal,
    bound: blank_object(),
    // lifecycle
    on_mount: [],
    on_destroy: [],
    before_update: [],
    after_update: [],
    context: new Map(parent_component ? parent_component.$$.context : []),
    // everything else
    callbacks: blank_object(),
    dirty: dirty
  };
  var ready = false;
  $$.ctx = instance ? instance(component, prop_values, function (i, ret) {
    var value = (arguments.length <= 2 ? 0 : arguments.length - 2) ? arguments.length <= 2 ? undefined : arguments[2] : ret;

    if ($$.ctx && not_equal($$.ctx[i], $$.ctx[i] = value)) {
      if ($$.bound[i]) $$.bound[i](value);
      if (ready) make_dirty(component, i);
    }

    return ret;
  }) : [];
  $$.update();
  ready = true;
  run_all($$.before_update); // `false` as a special case of no DOM component

  $$.fragment = create_fragment ? create_fragment($$.ctx) : false;

  if (options.target) {
    if (options.hydrate) {
      var nodes = children(options.target); // eslint-disable-next-line @typescript-eslint/no-non-null-assertion

      $$.fragment && $$.fragment.l(nodes);
      nodes.forEach(detach);
    } else {
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      $$.fragment && $$.fragment.c();
    }

    if (options.intro) transition_in(component.$$.fragment);
    mount_component(component, options.target, options.anchor);
    flush();
  }

  set_current_component(parent_component);
}

var SvelteElement;

if (typeof HTMLElement === 'function') {
  SvelteElement =
  /*#__PURE__*/
  function (_CustomElement2) {
    _inherits(SvelteElement, _CustomElement2);

    function SvelteElement() {
      var _this;

      _classCallCheck(this, SvelteElement);

      _this = _possibleConstructorReturn(this, _getPrototypeOf(SvelteElement).call(this));

      _this.attachShadow({
        mode: 'open'
      });

      return _this;
    }

    _createClass(SvelteElement, [{
      key: "connectedCallback",
      value: function connectedCallback() {
        // @ts-ignore todo: improve typings
        for (var key in this.$$.slotted) {
          // @ts-ignore todo: improve typings
          this.appendChild(this.$$.slotted[key]);
        }
      }
    }, {
      key: "attributeChangedCallback",
      value: function attributeChangedCallback(attr, _oldValue, newValue) {
        this[attr] = newValue;
      }
    }, {
      key: "$destroy",
      value: function $destroy() {
        destroy_component(this, 1);
        this.$destroy = noop;
      }
    }, {
      key: "$on",
      value: function $on(type, callback) {
        // TODO should this delegate to addEventListener?
        var callbacks = this.$$.callbacks[type] || (this.$$.callbacks[type] = []);
        callbacks.push(callback);
        return function () {
          var index = callbacks.indexOf(callback);
          if (index !== -1) callbacks.splice(index, 1);
        };
      }
    }, {
      key: "$set",
      value: function $set() {// overridden by instance, if it has props
      }
    }]);

    return SvelteElement;
  }(_CustomElement);
}

var tooltip = {
  "dls-typography-desktop-body-reg-small": "mc7bda60ce_dls-typography-desktop-body-reg-small",
  "dls-typography-desktop-body-med-small": "mc7bda60ce_dls-typography-desktop-body-med-small",
  "tooltip": "mc7bda60ce_tooltip",
  "top": "mc7bda60ce_top",
  "bottom": "mc7bda60ce_bottom",
  "left": "mc7bda60ce_left",
  "right": "mc7bda60ce_right",
  "open": "mc7bda60ce_open",
  "trigger": "mc7bda60ce_trigger",
  "underline": "mc7bda60ce_underline",
  "triggerGlyph": "mc7bda60ce_triggerGlyph",
  "window": "mc7bda60ce_dls-typography-desktop-body-reg-small mc7bda60ce_window",
  "_windowHead": "mc7bda60ce_dls-typography-desktop-body-med-small mc7bda60ce__windowHead",
  "_windowFoot": "mc7bda60ce__windowFoot",
  "standard": "mc7bda60ce_standard",
  "toggletip": "mc7bda60ce_toggletip",
  "labeltip": "mc7bda60ce_labeltip",
  "empty": "mc7bda60ce_empty"
};
var tooltip$1 = "mc7bda60ce_tooltip";
var top = "mc7bda60ce_top";
var bottom = "mc7bda60ce_bottom";
var left = "mc7bda60ce_left";
var right = "mc7bda60ce_right";
var open = "mc7bda60ce_open";
var trigger = "mc7bda60ce_trigger";
var underline = "mc7bda60ce_underline";
var triggerGlyph = "mc7bda60ce_triggerGlyph";
var window$1 = "mc7bda60ce_dls-typography-desktop-body-reg-small mc7bda60ce_window";
var _windowHead = "mc7bda60ce_dls-typography-desktop-body-med-small mc7bda60ce__windowHead";
var _windowFoot = "mc7bda60ce__windowFoot";
var standard = "mc7bda60ce_standard";
var toggletip = "mc7bda60ce_toggletip";
var labeltip = "mc7bda60ce_labeltip";
var empty$1 = "mc7bda60ce_empty";
var styles = ".mc7bda60ce_dls-typography-desktop-body-reg-small{font-family:Lab Grotesque,sans-serif;font-weight:400;text-transform:none;font-size:14px;letter-spacing:0;line-height:20px}.mc7bda60ce_dls-typography-desktop-body-med-small{font-family:Lab Grotesque,sans-serif;font-weight:500;text-transform:none;font-size:14px;letter-spacing:0;line-height:20px}.mc7bda60ce_tooltip{position:relative;display:inline-block}.mc7bda60ce_trigger{align-items:flex-end;display:inline-flex;padding-bottom:4px}.mc7bda60ce_underline .mc7bda60ce_trigger{background-image:linear-gradient(90deg,#007e8c 0,#007e8c 50%,transparent 0,transparent);background-position:0 calc(1em + 5px);background-repeat:repeat-x;background-size:4px 1px}.mc7bda60ce_tooltip.mc7bda60ce_underline:focus .mc7bda60ce_trigger,.mc7bda60ce_tooltip.mc7bda60ce_underline:hover .mc7bda60ce_trigger{background-image:linear-gradient(90deg,#007e8c 0,#007e8c)}.mc7bda60ce_triggerGlyph{color:#007e8c;margin:0 0 4px 4px}.mc7bda60ce_window{border-radius:4px;opacity:0;margin:8px 0;padding:8px 12px;pointer-events:none;position:absolute;text-align:left;transition:opacity .15s ease-out 0ms,transform .15s ease-out 0ms;width:auto;z-index:2}.mc7bda60ce_window:before{content:\"\";display:block;height:8px;left:0;position:absolute;width:100%}.mc7bda60ce_bottom .mc7bda60ce_window:before{top:-8px}.mc7bda60ce_top .mc7bda60ce_window:before{bottom:-8px}.mc7bda60ce__windowFoot{display:inline-block;margin-top:12px}.mc7bda60ce_standard .mc7bda60ce_window{max-width:183px;width:183px;width:-webkit-max-content;width:max-content}.mc7bda60ce_toggletip .mc7bda60ce_window{max-width:183px;transition-delay:0ms!important;width:183px;width:-webkit-max-content;width:max-content}.mc7bda60ce_labeltip .mc7bda60ce_window{text-transform:uppercase;white-space:nowrap}.mc7bda60ce_top .mc7bda60ce_window{bottom:100%;transform:translateY(8px)}.mc7bda60ce_bottom .mc7bda60ce_window{top:100%;transform:translateY(-8px)}.mc7bda60ce_left .mc7bda60ce_window{left:0}.mc7bda60ce_right .mc7bda60ce_window{right:0}.mc7bda60ce_open .mc7bda60ce_window{opacity:1;pointer-events:auto;transform:translateY(0)}.mc7bda60ce_empty{display:none}";
var tooltipStyles =
/*#__PURE__*/
Object.freeze({
  __proto__: null,
  'default': tooltip,
  tooltip: tooltip$1,
  top: top,
  bottom: bottom,
  left: left,
  right: right,
  open: open,
  trigger: trigger,
  underline: underline,
  triggerGlyph: triggerGlyph,
  window: window$1,
  _windowHead: _windowHead,
  _windowFoot: _windowFoot,
  standard: standard,
  toggletip: toggletip,
  labeltip: labeltip,
  empty: empty$1,
  styles: styles
});
var window$2 = "mc447d2e4b_window";
var styles$1 = ".mc447d2e4b_window{background:#3e3939;box-shadow:0 4px 12px 0 rgba(0,0,0,.12);color:#fff}";
var tooltipStyleStore = SvelteStyleStoreFactory();
var subscribe$1 = tooltipStyleStore.subscribe,
    addStyles = tooltipStyleStore.addStyles;
addStyles([{
  attributeName: 'theme',
  attributeValue: 'dark',
  className: 'ignore',
  styles: styles$1,
  parts: {
    window: window$2
  }
}]);
var document_1 = globals.document;

function create_if_block_1(ctx) {
  var html_tag;
  return {
    c: function c() {
      html_tag = new HtmlTag(
      /*polyfillStyleTags*/
      ctx[5], null);
    },
    m: function m(target, anchor) {
      html_tag.m(target, anchor);
    },
    p: function p(ctx, dirty) {
      if (dirty[0] &
      /*polyfillStyleTags*/
      32) html_tag.p(
      /*polyfillStyleTags*/
      ctx[5]);
    },
    d: function d(detaching) {
      if (detaching) html_tag.d();
    }
  };
} // (7:0) {#if !style.usesPolyfill}


function create_if_block(ctx) {
  var div0;
  var t;
  var div1;
  var raw1_value =
  /*$altStyles*/
  ctx[12].sheet("theme/".concat(
  /*theme*/
  ctx[2])) + "";
  return {
    c: function c() {
      div0 = element("div");
      t = space();
      div1 = element("div");
      attr(div0, "data-style", "");
      attr(div1, "data-style", "");
    },
    m: function m(target, anchor) {
      insert(target, div0, anchor);
      div0.innerHTML =
      /*stylesheet*/
      ctx[13];
      insert(target, t, anchor);
      insert(target, div1, anchor);
      div1.innerHTML = raw1_value;
    },
    p: function p(ctx, dirty) {
      if (dirty[0] &
      /*$altStyles, theme*/
      4100 && raw1_value !== (raw1_value =
      /*$altStyles*/
      ctx[12].sheet("theme/".concat(
      /*theme*/
      ctx[2])) + "")) div1.innerHTML = raw1_value;
    },
    d: function d(detaching) {
      if (detaching) detach(div0);
      if (detaching) detach(t);
      if (detaching) detach(div1);
    }
  };
}

function create_fragment(ctx) {
  var if_block0_anchor;
  var t0;
  var t1;
  var div1;
  var span0;
  var slot0;
  var t2;
  var slot1;
  var t3;
  var html_tag;
  var span0_class_value;
  var t4;
  var div0;
  var dls_panel;
  var span1;
  var slot2;
  var span1_class_value;
  var t5;
  var slot3;
  var t6;
  var t7;
  var span2;
  var slot4;
  var span2_class_value;
  var div0_class_value;
  var div1_class_value;
  var initialize_action;
  var dispose;
  var if_block0 =
  /*style*/
  ctx[14].usesPolyfill && create_if_block_1(ctx);
  var if_block1 = !
  /*style*/
  ctx[14].usesPolyfill && create_if_block(ctx);
  return {
    c: function c() {
      if (if_block0) if_block0.c();
      if_block0_anchor = empty();
      t0 = space();
      if (if_block1) if_block1.c();
      t1 = space();
      div1 = element("div");
      span0 = element("span");
      slot0 = element("slot");
      t2 = space();
      slot1 = element("slot");
      t3 = space();
      t4 = space();
      div0 = element("div");
      dls_panel = element("dls-panel");
      span1 = element("span");
      slot2 = element("slot");
      t5 = space();
      slot3 = element("slot");
      t6 = text(
      /*text*/
      ctx[0]);
      t7 = space();
      span2 = element("span");
      slot4 = element("slot");
      this.c = noop;
      attr(slot0, "name", "tooltip-trigger");
      html_tag = new HtmlTag(
      /*formattedGlyph*/
      ctx[8], null);
      attr(span0, "class", span0_class_value = "" + (
      /*style*/
      ctx[14].is("trigger") + " " +
      /*$altStyles*/
      ctx[12].part("theme/".concat(
      /*theme*/
      ctx[2], "/trigger")) + " " +
      /*themeVariants*/
      ctx[7]));
      attr(span0, "aria-describedby",
      /*ariaDescribedby*/
      ctx[10]);
      attr(span0, "aria-labelledby",
      /*ariaLabelledby*/
      ctx[9]);
      attr(slot2, "name", "tooltip-window-head");
      attr(span1, "class", span1_class_value =
      /*style*/
      ctx[14].are("_windowHead", "empty"));
      attr(span1, "slot", "panel-head");
      attr(slot3, "name", "tooltip-window-body");
      attr(slot3, "slot", "panel-body");
      attr(slot4, "name", "tooltip-window-foot");
      attr(span2, "class", span2_class_value =
      /*style*/
      ctx[14].are("_windowFoot", "empty"));
      attr(span2, "slot", "panel-foot");
      set_custom_element_data(dls_panel, "theme", "tooltip");
      attr(div0, "id", "tooltip-window");
      attr(div0, "class", div0_class_value = "" + (
      /*style*/
      ctx[14].is("window") + " " +
      /*$altStyles*/
      ctx[12].part("theme/".concat(
      /*theme*/
      ctx[2], "/window")) + " " +
      /*themeVariants*/
      ctx[7]));
      set_style(div0, "transition-delay",
      /*delay*/
      ctx[1] + "ms");
      attr(div0, "aria-hidden",
      /*ariaHidden*/
      ctx[11]);
      attr(div1, "class", div1_class_value = "" + (
      /*style*/
      ctx[14].is("tooltip") + " " +
      /*$altStyles*/
      ctx[12].part("theme/".concat(
      /*theme*/
      ctx[2], "/tooltip")) + " " +
      /*optionalClassNames*/
      ctx[6] + " " +
      /*themeVariants*/
      ctx[7]));
    },
    m: function m(target, anchor) {
      if (if_block0) if_block0.m(document_1.head, null);
      append(document_1.head, if_block0_anchor);
      insert(target, t0, anchor);
      if (if_block1) if_block1.m(target, anchor);
      insert(target, t1, anchor);
      insert(target, div1, anchor);
      append(div1, span0);
      append(span0, slot0);
      append(span0, t2);
      append(span0, slot1);
      append(span0, t3);
      html_tag.m(span0);
      /*span0_binding*/

      ctx[48](span0);
      append(div1, t4);
      append(div1, div0);
      append(div0, dls_panel);
      append(dls_panel, span1);
      append(span1, slot2);
      append(dls_panel, t5);
      append(dls_panel, slot3);
      append(slot3, t6);
      append(dls_panel, t7);
      append(dls_panel, span2);
      append(span2, slot4);
      /*div0_binding*/

      ctx[49](div0);
      dispose = [listen(slot2, "slotchange",
      /*checkForSlotted*/
      ctx[15]), listen(slot4, "slotchange",
      /*checkForSlotted*/
      ctx[15]), action_destroyer(initialize_action =
      /*initialize*/
      ctx[16].call(null, div1))];
    },
    p: function p(ctx, dirty) {
      if (
      /*style*/
      ctx[14].usesPolyfill) if_block0.p(ctx, dirty);
      if (!
      /*style*/
      ctx[14].usesPolyfill) if_block1.p(ctx, dirty);
      if (dirty[0] &
      /*formattedGlyph*/
      256) html_tag.p(
      /*formattedGlyph*/
      ctx[8]);

      if (dirty[0] &
      /*$altStyles, theme, themeVariants*/
      4228 && span0_class_value !== (span0_class_value = "" + (
      /*style*/
      ctx[14].is("trigger") + " " +
      /*$altStyles*/
      ctx[12].part("theme/".concat(
      /*theme*/
      ctx[2], "/trigger")) + " " +
      /*themeVariants*/
      ctx[7]))) {
        attr(span0, "class", span0_class_value);
      }

      if (dirty[0] &
      /*ariaDescribedby*/
      1024) {
        attr(span0, "aria-describedby",
        /*ariaDescribedby*/
        ctx[10]);
      }

      if (dirty[0] &
      /*ariaLabelledby*/
      512) {
        attr(span0, "aria-labelledby",
        /*ariaLabelledby*/
        ctx[9]);
      }

      if (dirty[0] &
      /*text*/
      1) set_data(t6,
      /*text*/
      ctx[0]);

      if (dirty[0] &
      /*$altStyles, theme, themeVariants*/
      4228 && div0_class_value !== (div0_class_value = "" + (
      /*style*/
      ctx[14].is("window") + " " +
      /*$altStyles*/
      ctx[12].part("theme/".concat(
      /*theme*/
      ctx[2], "/window")) + " " +
      /*themeVariants*/
      ctx[7]))) {
        attr(div0, "class", div0_class_value);
      }

      if (dirty[0] &
      /*delay*/
      2) {
        set_style(div0, "transition-delay",
        /*delay*/
        ctx[1] + "ms");
      }

      if (dirty[0] &
      /*ariaHidden*/
      2048) {
        attr(div0, "aria-hidden",
        /*ariaHidden*/
        ctx[11]);
      }

      if (dirty[0] &
      /*$altStyles, theme, optionalClassNames, themeVariants*/
      4292 && div1_class_value !== (div1_class_value = "" + (
      /*style*/
      ctx[14].is("tooltip") + " " +
      /*$altStyles*/
      ctx[12].part("theme/".concat(
      /*theme*/
      ctx[2], "/tooltip")) + " " +
      /*optionalClassNames*/
      ctx[6] + " " +
      /*themeVariants*/
      ctx[7]))) {
        attr(div1, "class", div1_class_value);
      }
    },
    i: noop,
    o: noop,
    d: function d(detaching) {
      if (if_block0) if_block0.d(detaching);
      detach(if_block0_anchor);
      if (detaching) detach(t0);
      if (if_block1) if_block1.d(detaching);
      if (detaching) detach(t1);
      if (detaching) detach(div1);
      /*span0_binding*/

      ctx[48](null);
      /*div0_binding*/

      ctx[49](null);
      run_all(dispose);
    }
  };
}

function getAriaLabelledby(type, disabled) {
  if (disabled) {
    return null;
  }

  return type === "labeltip" ? "tooltip-window" : null;
}

function getAriaDescribedby(type, disabled) {
  if (disabled) {
    return null;
  }

  return type === "labeltip" ? null : "tooltip-window";
}

function getAriaHidden(open) {
  return !open;
}

function getIndicatorClass(indicator, disabled) {
  return indicator === "none" || disabled ? "noIndicator" : indicator;
}

function instance($$self, $$props, $$invalidate) {
  var $altStyles;
  component_subscribe($$self, tooltipStyleStore, function ($$value) {
    return $$invalidate(12, $altStyles = $$value);
  });
  var stylesheet = "<style id=\"tooltip-styles\">".concat(styles, "</style>");
  var style = new StyleUtilities(tooltipStyles);
  var checkForSlotted = getCheckForSlotted(style.is("empty"));
  var tooltipElement, hostElement, triggerElement, windowElement;
  var _$$props$align = $$props.align,
      align = _$$props$align === void 0 ? "left" : _$$props$align;
  var _$$props$disabled = $$props.disabled,
      disabled = _$$props$disabled === void 0 ? false : _$$props$disabled;
  var _$$props$text = $$props.text,
      text = _$$props$text === void 0 ? null : _$$props$text;
  var _$$props$delay = $$props.delay,
      delay = _$$props$delay === void 0 ? 500 : _$$props$delay;
  var _$$props$glyph = $$props.glyph,
      glyph = _$$props$glyph === void 0 ? "tooltip-small" : _$$props$glyph;
  var _$$props$indicator = $$props.indicator,
      indicator = _$$props$indicator === void 0 ? "underline" : _$$props$indicator;
  var _$$props$open = $$props.open,
      open = _$$props$open === void 0 ? false : _$$props$open;
  var _$$props$position = $$props.position,
      position = _$$props$position === void 0 ? "bottom" : _$$props$position;
  var _$$props$theme = $$props.theme,
      theme = _$$props$theme === void 0 ? "dark" : _$$props$theme;
  var _$$props$type = $$props.type,
      type = _$$props$type === void 0 ? "standard" : _$$props$type;

  function initialize(node) {
    $$invalidate(24, tooltipElement = node);
    hostElement = node.parentNode.host;
  }

  function addEventListeners(tooltip, trigger, window, type, disabled) {
    if (tooltip === undefined || trigger === undefined) {
      return;
    }

    removeEventListeners(tooltip, trigger);

    if (disabled) {
      return;
    }

    if (type === "toggletip") {
      trigger.addEventListener("click", toggleTipWindow);
    } else {
      tooltip.addEventListener("mouseenter", openTipWindow);
      tooltip.addEventListener("focusin", openTipWindow);
      tooltip.addEventListener("mouseleave", closeTipWindow);
      tooltip.addEventListener("focusout", closeTipWindow);
    }
  }

  function removeEventListeners(tooltip, trigger) {
    trigger.removeEventListener("click", toggleTipWindow);
    tooltip.removeEventListener("mouseenter", openTipWindow);
    tooltip.removeEventListener("focusin", openTipWindow);
    tooltip.removeEventListener("mouseleave", closeTipWindow);
    tooltip.removeEventListener("focusout", closeTipWindow);
  }

  function toggleTipWindow() {
    if (open) {
      closeTipWindow();
    } else {
      openTipWindow();
    }
  }

  function closeTipWindow() {
    hostElement.removeAttribute("open");
    removeWindowPositionListeners();
    dispatchCloseEvent();
  }

  function openTipWindow() {
    resetPreferredOrientation();
    positionWindow();
    addWindowPositionListeners();
    hostElement.setAttribute("open", "open");
    dispatchOpenEvent();
  }

  function dispatchCloseEvent() {
    hostElement.dispatchEvent(new CustomEvent("dlstooltipclose", {
      bubbles: true
    }));
  }

  function dispatchOpenEvent() {
    hostElement.dispatchEvent(new CustomEvent("dlstooltipopen", {
      bubbles: true
    }));
  }

  function getThemeVariants(align, disabled, indicator, open, position, type) {
    indicator = getIndicatorClass(indicator);
    var variants = [align && $altStyles.variant("theme/".concat(theme, "/").concat(align)), disabled && $altStyles.variant("theme/".concat(theme, "/disabled")), indicator && $altStyles.variant("theme/".concat(theme, "/").concat(indicator)), open && $altStyles.variant("theme/".concat(theme, "/open")), position && $altStyles.variant("theme/".concat(theme, "/").concat(position)), type && $altStyles.variant("theme/".concat(theme, "/").concat(type))].filter(Boolean).join(" ");
    return variants.length ? variants : "";
  }

  function gerIghttionalClassNames(align, disabled, indicator, open, position, theme, type) {
    indicator = getIndicatorClass(indicator, disabled);
    var optionalClassNames = [style.is(align), style.is(indicator), style.is(position), style.is(type), $altStyles.style("theme/".concat(theme)), open && style.is("open")].filter(Boolean).join(" ");
    return optionalClassNames.length ? optionalClassNames : "";
  }

  function getFormattedGlyph(glyph, indicator, theme, themeVariants) {
    var showGlyph = indicator === "icon" && !disabled;
    var glyphClasses = "".concat(style.is("triggerGlyph"), " ").concat($altStyles.part("theme/".concat(theme, "/triggerGlyph")), " ").concat(themeVariants);
    return showGlyph ? "<dls-icon-".concat(glyph, " class=\"").concat(glyphClasses, "\"></dls-icon-").concat(glyph, ">") : "";
  }

  function generatePolyfillStyleTags() {
    var tags = polyfillStyleTags;

    if (tooltipStyleStore.isNewStylesheet("tooltip-styles")) {
      tags += stylesheet;
    }

    if (tooltipStyleStore.isNewStylesheet("theme/".concat(theme))) {
      tags += $altStyles.sheet("theme/".concat(theme));
    }

    return tags;
  }
  /* TODO: replace with shared utility */


  var alignFlipped = false,
      positionFlipped = false;
  var lastCall = null,
      lastDuration = null,
      pendingTimeout = null;

  function addWindowPositionListeners() {
    ["resize", "scroll", "touchmove"].forEach(function (event) {
      window.addEventListener(event, tick);
    });
  }

  function removeWindowPositionListeners() {
    ["resize", "scroll", "touchmove"].forEach(function (event) {
      window.removeEventListener(event, tick);
    });
  }

  function checkPreferredOrientation() {
    var defaultAlign = hostElement.getAttribute("align") || "left";
    var defaultPosition = hostElement.getAttribute("position") || "bottom";
    alignFlipped = align !== defaultAlign;
    positionFlipped = position !== defaultPosition;
  }

  function resetPreferredOrientation() {
    $$invalidate(17, align = hostElement.getAttribute("align") || "left");
    $$invalidate(18, position = hostElement.getAttribute("position") || "bottom");
  }

  function positionWindow() {
    var pageBounds = document.body.getBoundingClientRect();
    var triggerBounds = triggerElement.getBoundingClientRect();
    var tipWindowWidth = windowElement.offsetWidth;
    var tipWindowHeight = windowElement.offsetHeight;
    var documentWindowHeight = window.innerHeight;
    var collisions = {
      top: triggerBounds.top - tipWindowHeight < 0,
      right: pageBounds.width < triggerBounds.left + tipWindowWidth,
      bottom: documentWindowHeight < triggerBounds.top + triggerBounds.height + tipWindowHeight,
      left: triggerBounds.right - tipWindowWidth < 0
    };
    checkPreferredOrientation();

    if (collisions.left) {
      $$invalidate(17, align = "left");
    } else if (alignFlipped) {
      $$invalidate(17, align = "right");
    }

    if (collisions.right) {
      $$invalidate(17, align = "right");
    } else if (alignFlipped) {
      $$invalidate(17, align = "left");
    }

    if (collisions.top) {
      $$invalidate(18, position = "bottom");
    } else if (positionFlipped) {
      $$invalidate(18, position = "top");
    }

    if (collisions.bottom) {
      $$invalidate(18, position = "top");
    } else if (positionFlipped) {
      $$invalidate(18, position = "bottom");
    }
  }

  var tick = function tick() {
    /* Lightly modified from tether.js */
    if (typeof lastDuration !== "undefined" && lastDuration > 16) {
      // We voluntarily throttle ourselves if we can't manage 60fps
      lastDuration = Math.min(lastDuration - 16, 250); // Just in case this is the last event, remember to position just once more

      pendingTimeout = setTimeout(tick, 250);
      return;
    }

    if (typeof lastCall !== "undefined" && Date.now() - lastCall < 10) {
      // Some browsers call events a little too frequently, refuse to run more than is reasonable
      return;
    }

    if (pendingTimeout != null) {
      clearTimeout(pendingTimeout);
      pendingTimeout = null;
    }

    lastCall = Date.now();
    positionWindow();
    lastDuration = Date.now() - lastCall;
  };

  function span0_binding($$value) {
    binding_callbacks[$$value ? "unshift" : "push"](function () {
      $$invalidate(3, triggerElement = $$value);
    });
  }

  function div0_binding($$value) {
    binding_callbacks[$$value ? "unshift" : "push"](function () {
      $$invalidate(4, windowElement = $$value);
    });
  }

  $$self.$set = function ($$props) {
    if ("align" in $$props) $$invalidate(17, align = $$props.align);
    if ("disabled" in $$props) $$invalidate(19, disabled = $$props.disabled);
    if ("text" in $$props) $$invalidate(0, text = $$props.text);
    if ("delay" in $$props) $$invalidate(1, delay = $$props.delay);
    if ("glyph" in $$props) $$invalidate(20, glyph = $$props.glyph);
    if ("indicator" in $$props) $$invalidate(21, indicator = $$props.indicator);
    if ("open" in $$props) $$invalidate(22, open = $$props.open);
    if ("position" in $$props) $$invalidate(18, position = $$props.position);
    if ("theme" in $$props) $$invalidate(2, theme = $$props.theme);
    if ("type" in $$props) $$invalidate(23, type = $$props.type);
  };

  var polyfillStyleTags;
  var optionalClassNames;
  var themeVariants;
  var formattedGlyph;
  var ariaLabelledby;
  var ariaDescribedby;
  var ariaHidden;

  $$self.$$.update = function () {
    if ($$self.$$.dirty[0] &
    /*theme*/
    4) {
      $$invalidate(5, polyfillStyleTags = style.usesPolyfill ? generatePolyfillStyleTags() : null);
    }

    if ($$self.$$.dirty[0] &
    /*align, disabled, indicator, open, position, theme, type*/
    15597572) {
      $$invalidate(6, optionalClassNames = gerIghttionalClassNames(align, disabled, indicator, open, position, theme, type));
    }

    if ($$self.$$.dirty[0] &
    /*align, disabled, indicator, open, position, type*/
    15597568) {
      $$invalidate(7, themeVariants = getThemeVariants(align, disabled, indicator, open, position, type));
    }

    if ($$self.$$.dirty[0] &
    /*glyph, indicator, theme, themeVariants*/
    3145860) {
      $$invalidate(8, formattedGlyph = getFormattedGlyph(glyph, indicator, theme, themeVariants));
    }

    if ($$self.$$.dirty[0] &
    /*type, disabled*/
    8912896) {
      $$invalidate(9, ariaLabelledby = getAriaLabelledby(type, disabled));
    }

    if ($$self.$$.dirty[0] &
    /*type, disabled*/
    8912896) {
      $$invalidate(10, ariaDescribedby = getAriaDescribedby(type, disabled));
    }

    if ($$self.$$.dirty[0] &
    /*open*/
    4194304) {
      $$invalidate(11, ariaHidden = getAriaHidden(open));
    }

    if ($$self.$$.dirty[0] &
    /*tooltipElement, triggerElement, windowElement, type, disabled*/
    25690136) {
      addEventListeners(tooltipElement, triggerElement, windowElement, type, disabled);
    }
  };

  return [text, delay, theme, triggerElement, windowElement, polyfillStyleTags, optionalClassNames, themeVariants, formattedGlyph, ariaLabelledby, ariaDescribedby, ariaHidden, $altStyles, stylesheet, style, checkForSlotted, initialize, align, position, disabled, glyph, indicator, open, type, tooltipElement, hostElement, alignFlipped, positionFlipped, lastCall, lastDuration, pendingTimeout, addEventListeners, removeEventListeners, toggleTipWindow, closeTipWindow, openTipWindow, dispatchCloseEvent, dispatchOpenEvent, getThemeVariants, gerIghttionalClassNames, getFormattedGlyph, generatePolyfillStyleTags, addWindowPositionListeners, removeWindowPositionListeners, checkPreferredOrientation, resetPreferredOrientation, positionWindow, tick, span0_binding, div0_binding];
}

var DlsTooltips =
/*#__PURE__*/
function (_SvelteElement) {
  _inherits(DlsTooltips, _SvelteElement);

  function DlsTooltips(options) {
    var _this;

    _classCallCheck(this, DlsTooltips);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(DlsTooltips).call(this));
    init(_assertThisInitialized(_this), {
      target: _this.shadowRoot
    }, instance, create_fragment, safe_not_equal, {
      align: 17,
      disabled: 19,
      text: 0,
      delay: 1,
      glyph: 20,
      indicator: 21,
      open: 22,
      position: 18,
      theme: 2,
      type: 23
    }, [-1, -1]);

    if (options) {
      if (options.target) {
        insert(options.target, _assertThisInitialized(_this), options.anchor);
      }

      if (options.props) {
        _this.$set(options.props);

        flush();
      }
    }

    return _this;
  }

  _createClass(DlsTooltips, [{
    key: "align",
    get: function get() {
      return this.$$.ctx[17];
    },
    set: function set(align) {
      this.$set({
        align: align
      });
      flush();
    }
  }, {
    key: "disabled",
    get: function get() {
      return this.$$.ctx[19];
    },
    set: function set(disabled) {
      this.$set({
        disabled: disabled
      });
      flush();
    }
  }, {
    key: "text",
    get: function get() {
      return this.$$.ctx[0];
    },
    set: function set(text) {
      this.$set({
        text: text
      });
      flush();
    }
  }, {
    key: "delay",
    get: function get() {
      return this.$$.ctx[1];
    },
    set: function set(delay) {
      this.$set({
        delay: delay
      });
      flush();
    }
  }, {
    key: "glyph",
    get: function get() {
      return this.$$.ctx[20];
    },
    set: function set(glyph) {
      this.$set({
        glyph: glyph
      });
      flush();
    }
  }, {
    key: "indicator",
    get: function get() {
      return this.$$.ctx[21];
    },
    set: function set(indicator) {
      this.$set({
        indicator: indicator
      });
      flush();
    }
  }, {
    key: "open",
    get: function get() {
      return this.$$.ctx[22];
    },
    set: function set(open) {
      this.$set({
        open: open
      });
      flush();
    }
  }, {
    key: "position",
    get: function get() {
      return this.$$.ctx[18];
    },
    set: function set(position) {
      this.$set({
        position: position
      });
      flush();
    }
  }, {
    key: "theme",
    get: function get() {
      return this.$$.ctx[2];
    },
    set: function set(theme) {
      this.$set({
        theme: theme
      });
      flush();
    }
  }, {
    key: "type",
    get: function get() {
      return this.$$.ctx[23];
    },
    set: function set(type) {
      this.$set({
        type: type
      });
      flush();
    }
  }], [{
    key: "observedAttributes",
    get: function get() {
      return ["align", "disabled", "text", "delay", "glyph", "indicator", "open", "position", "theme", "type"];
    }
  }]);

  return DlsTooltips;
}(SvelteElement);

var elements = [{
  tagName: 'dls-tooltip',
  customElement: DlsTooltips
}];
elements.forEach(function (_ref) {
  var tagName = _ref.tagName,
      customElement = _ref.customElement; // TODO: create shared utility later
  // TODO: don't call by default later, will be breaking change

  try {
    window.customElements.define(tagName, customElement);
  } catch (error) {// TODO: See https://github.com/collectivehealth/dls/issues/552
  }
});
export default DlsTooltips;
export { addStyles };